<template>
  <v-list-item class="courses-list-header px-2">
    <v-list-item-avatar width="68" class="ma-0">
      <span class="courses-list-header-item ml-1 mr-auto">Name</span>
    </v-list-item-avatar>
    <v-list-item-content class="px-2"> </v-list-item-content>
    <v-list-item-content class="px-2" v-if="!isLibraryItem || isAdvisor">
      <span class="courses-list-header-item">Participants</span>
    </v-list-item-content>
    <v-list-item-content class="px-2" v-if="!isLibraryItem">
      <span class="courses-list-header-item">Rating</span>
    </v-list-item-content>
    <v-list-item-content class="px-2">
      <span class="courses-list-header-item">Visibility</span>
    </v-list-item-content>
    <v-list-item-content class="px-2">
      <span class="courses-list-header-item">Date added</span>
    </v-list-item-content>
    <v-list-item-avatar
      :width="`${isLibraryItem ? (isAdvisor ? 187 : 101) : 64}`"
      class="ma-0"
    >
    </v-list-item-avatar>
  </v-list-item>
</template>

<script>
export default {
  components: {},
  name: 'CoursesListHeader',
  mixins: [],
  props: {
    isLibraryItem: {
      type: Boolean,
      default: false,
    },
    isAdvisor: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({}),
  computed: {},
  methods: {},
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.courses-list-header {
  min-width: 950px;
  &-item {
    font-size: 10px;
    line-height: 24px;
    letter-spacing: 1px;
    text-transform: uppercase;
    font-weight: 700;
    color: $bh-blue--2;
  }
}
</style>
